module.exports = __webpack_public_path__ + "img/icon_map_13_off_111.d1f0a6c5.png";